import { render, staticRenderFns } from "./RegionAdd.vue?vue&type=template&id=dac92d3e"
import script from "./RegionAdd.vue?vue&type=script&lang=js"
export * from "./RegionAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports